import React from 'react';

import { CellDescription } from '@atoms';

import s from './styles.module.less';

const TableTextColumn = ({ type, children }) => {
  return (
    <CellDescription label={type} className={s.title}>
      {children}
    </CellDescription>
  );
};

export default TableTextColumn;
